import React from "react";
import * as d3 from "d3";
import myLayout from '../layout/eventLayout';
import {Icon, List, Modal} from "antd";

const fontSize = 12;
const radio = 12;
const clientWidth = document.documentElement.clientWidth;
const clientHeight = document.documentElement.clientHeight;

function getTransformXY(p1) {
    const split = p1.attr('transform').split('scale');
    const t1 = split[0];
    const t2 = t1.substring(10, t1.length);
    const t3 = t2.substring(0, t2.length - 1).split(',');
    const x = parseFloat(t3[0]);
    const y = parseFloat(t3[1]);
    let scale = 1;
    if (split[1]) {
        const scaleStr = split[1];
        scale = parseFloat(scaleStr.substring(1, scaleStr.length - 1))
    }
    return {x: x, y: y, scale: scale}
}

function myBrowser() {
    const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    const isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
    const isIE = userAgent.indexOf("compatible") > -1
        && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
    const isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
    const isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
    const isSafari = userAgent.indexOf("Safari") > -1
        && userAgent.indexOf("Chrome") === -1; //判断是否Safari浏览器
    const isChrome = userAgent.indexOf("Chrome") > -1
        && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

    if (isIE) {
        const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        const fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion === 7) {
            return "IE7";
        } else if (fIEVersion === 8) {
            return "IE8";
        } else if (fIEVersion === 9) {
            return "IE9";
        } else if (fIEVersion === 10) {
            return "IE10";
        } else if (fIEVersion === 11) {
            return "IE11";
        } else {
            return "0";
        }
    }
    if (isOpera) {
        return "Opera";
    }
    if (isEdge) {
        return "Edge";
    }
    if (isFF) {
        return "FF";
    }
    if (isSafari) {
        return "Safari";
    }
    if (isChrome) {
        return "Chrome";
    }

}


export default class EventGraph extends React.Component {
    componentDidMount() {
        this.initFrame();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {timeList} = this.props;
        if (timeList.length > 0) {
            this.drawEvent();
        }
    }

    state = {
        entities: [],
        eventTitle: '',
        newsList: [],
        modalVisible: false,
    };

    initFrame = () => {
        d3.selectAll('#eventGraph>svg').remove();
        const svg = d3.select('#eventGraph')
            .append('svg')
            .attr('id', 'rootSvg')
            .attr('transform', 'translate(0,180)')
            .attr('width', '35vw')
            .attr('height', '80vh')
            .attr('display', 'inline')
            .style('position', 'absolute');


        //用于获取缩放事件
        svg.append('rect')
            .attr('class', 'zoom-rect')
            .attr('id', 'zoom-rect')
            .attr('width', '35vw')
            .attr('height', '80vh')
            .style('fill', 'rgba(0,0,0,0)');

        const container = svg.append('g')
            .attr('class', 'event-container')
            .attr('id', 'event-container')
            .attr('transform', 'translate(0,0)');
        container.append('g').attr('class', 'yAxis');
        container.append('g').attr('class', 'eventRelations-group');
        container.append('g').attr('class', 'event-group');

    };

    drawEvent = () => {
        const {timeList, events, eventRelations} = this.props;
        // const selected = this.props.eventSelected;

        //safari支持
        if (myBrowser() === 'Safari') {
            document.getElementById('rootSvg').style.top = '180px'
        }
        const eventGroup = d3.select('g.event-group');
        const yAxis = d3.select('g.yAxis');
        const length = timeList.length * 95;
        //绘制坐标轴
        const yScale = d3.scale.ordinal()
            .domain(timeList)
            .rangePoints([0, length]);
        const axis = d3.svg.axis()
            .scale(yScale)
            .orient('right');
        yAxis.selectAll('g.y').remove();
        yAxis.append('g')
            .attr('class', 'y axis')
            .attr('transform', 'translate(36,10)')
            .call(axis);

        // 顺滑拖拽
        const container = d3.select('#event-container');
        const zoomRect = d3.select('#zoom-rect');
        const zoom = d3.behavior.zoom()
            .scaleExtent([1, 1])
            .on('zoom', () => {
                const {sourceEvent} = d3.event;
                //坐标轴长度+95
                const offsetLength = -(length + 95 - clientHeight * .8);
                if (sourceEvent) {
                    const wheelDelta = sourceEvent.wheelDelta;
                    const movementY = sourceEvent.movementY;
                    const containerY = getTransformXY(container).y;
                    if (wheelDelta) {
                        if (containerY >= 0 && wheelDelta >= 0) {
                            container.attr('transform', 'translate(0,0)')
                        } else if (containerY <= offsetLength && wheelDelta <= 0) {
                            container.attr('transform', 'translate(0,' + offsetLength + ')')
                        } else {
                            container.attr('transform', 'translate(0,' + (containerY + wheelDelta) + ')')
                        }
                    } else if (movementY) {
                        if (containerY >= 0 && movementY >= 0) {
                            container.attr('transform', 'translate(0,0)')
                        } else if (containerY <= offsetLength && movementY <= 0) {
                            container.attr('transform', 'translate(0,' + offsetLength + ')')
                        } else {
                            container.attr('transform', 'translate(0,' + (containerY + movementY) + ')')
                        }
                    }
                }
            });
        container
            .attr('transform', 'translate(0,0)')
            .call(zoom);
        zoomRect.call(zoom);

        //标签相对做边界位移
        const offset = 40;
        eventGroup.attr('transform', 'translate(' + offset + ',0)');

        //生成事件节点数据
        events.forEach(data => {
            let label = data.label;
            label = label.length > 15 ? label.substring(0, 15) + '...' : label;
            data.label = label;
            data.yLocked = true;
            data.y = yScale(data.time) + 20;
            data.height = 25;
            data.width = label.length * (fontSize + 0.3) + fontSize * 2 + 15;
            data.selected = false;
        });
        //生成位置布局
        if (!events[0].x) {
            myLayout()
                .size([clientWidth * .2, length])
                .entityList(events)
                .start();
        }

        eventGroup.selectAll('g.event').remove();
        const eventUpdate = eventGroup.selectAll('g.event')
            .data(events);
        const eventG = eventUpdate.enter()
            .append('g')
            .attr('class', 'event')
            .style('cursor', 'pointer')
            .on('click', eventSelected)
            .on('mouseleave',eventPointerLeave)
            .on('mouseenter',eventPointerEnter);
        eventG.append('rect')
            .attr('x', data => data.x)
            .attr('y', data => data.y)
            .attr('rx', data => data.height / 2)
            .attr('width', data => data.width)
            .attr('height', data => data.height)
            .style('stroke', data => selectedColor(data.selected))
            .style('stroke-width', 1)
            .style('fill', '#8AA396');
        eventG.append('text')
            .attr('x', data => data.x + 10)
            .attr('y', data => data.y + (data.height + fontSize) / 2)
            .style('fill', data => selectedTextColor(data.selected))
            .style('font-size', fontSize)
            .attr('text-anchor', 'start')
            .attr('class', 'eventLabel')
            .text(data => data.label);

        eventG.append('circle')
            .attr('cx', data => data.x + data.width - radio)
            .attr('cy', data => data.y + data.height / 2)
            .attr('r', radio)
            .style('fill', data => data.eventColor);
        eventG.append('text')
            .attr('x', data => data.x + data.width - radio)
            .attr('y', data => data.y + data.height / 2 + 6)
            .style('fill', '#000')
            .style('font-size', 14)
            .attr('text-anchor', 'middle')
            .text(data => data.index + 1);


        d3.selectAll('g.event-edge').remove();
        const eventEdge = d3.select('g.eventRelations-group')
            .selectAll('g.event-edge')
            .data(eventRelations)
            .enter()
            .append('g')
            .attr('display', 'inline')
            .attr('class', 'event-edge');
        eventEdge.insert('path')
            .style('stroke', 'rgba(192, 192, 192, 0.5)')
            .style('stroke-width', 3)
            .style('fill', 'rgba(0,0,0,0)')
            .attr('d', genLinkPath);
        const relationGroup = eventEdge.append('g')
            .attr('transform', link => {
                let sx = link.source.x + link.source.width;
                let tx = link.target.x + link.target.width;
                let sy = link.source.y + link.source.height;
                let ty = link.target.y + link.target.height;
                if (sx > tx) {
                    let temp = sx;
                    sx = tx;
                    tx = temp;
                    temp = sy;
                    sy = ty;
                    ty = temp;
                }

                const x = tx - sx;
                const y = ty - sy;
                const r = Math.atan2(y, x) * 180 / Math.PI;

                return 'translate(' + (sx + tx) / 2 + ',' + (sy + ty) / 2 + ') rotate(' + r + ')';
            });
        relationGroup.append('rect')
            .attr('x', d => d.label.length * -7 - 7)
            .attr('y', -10)
            .style('fill', '#000')
            .style('stroke', 'rgba(192, 192, 192, 0.5)')
            .style('stroke-width', 1)
            .attr('height', 20)
            .attr('width', d => d.label.length * 14 + 14)
            .attr('rx', 9);
        relationGroup.append('text')
            .attr('x', d => d.label.length * -7)
            .attr('y', 5)
            .style('fill', '#ff7f0e')
            .style('font-size', 14)
            .style('text-anchor', 'start')
            .text(d => d.label)
        ;

        function eventPointerEnter(data) {
            const clientWidth = document.documentElement.clientWidth;

            const eventContainer = d3.select('#eventGraph g.event-container');
            const entityContainer = d3.select('#entityGraph g.container');

            const svg = d3.select('#event-index' + (data.index + 1));
            svg.attr('fill', 'red')
            if (myBrowser() === 'Safari') {
                const id = 'event-index' + (data.index + 1);
                document.getElementById(id).style.left = (data.x + data.width + offset) + 'px';
            }
            let list = [];
            const color = {
                location: '#8345a4',
                person: '#99ce7e',
                organization: '#e6b34e'
            };
            const entityTransform = getTransformXY(entityContainer);
            data.entities.forEach(entity => {
                if (entity.x && entity.y) {
                    const targetOffsetX = entity.x * entityTransform.scale + entityTransform.x;
                    const targetOffsetY = entity.y * entityTransform.scale + entityTransform.y;
                    list.push({
                        category: entity.category,
                        sourceX: 0,
                        //模块位移180，事件条目位移13
                        sourceY: data.y + 180 + 12.5 + getTransformXY(eventContainer).y,
                        targetX: document.documentElement.clientWidth * 0.3 - (data.x + data.width + offset) + targetOffsetX - global.nodeConf[entity.size]['nodeRadio'] + 5,
                        targetY: document.documentElement.clientHeight * 0.1 + targetOffsetY + 5
                    })
                }
            });

            svg.selectAll('path').remove();
            svg.selectAll('path')
                .data(list)
                .enter()
                .append('path')
                .style('stroke', d => color[d.category])
                .style('stroke-width', 2)
                .style('fill', 'rgba(0,0,0,0)')
                .attr('d', d => {
                    const p0 = {x: d.sourceX, y: d.sourceY};
                    const p3 = {x: d.targetX, y: d.targetY};
                    const mx = (p0.x + p3.x) / 2;
                    let p = [p0, {
                        x: mx,
                        y: p0.y
                    }, {
                        x: mx,
                        y: p3.y
                    }, p3];

                    p = p.map(d => [d.x, d.y]);
                    return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
                });
            svg.transition()
                .ease('linear')
                .duration(500)
                .attr('width', clientWidth - offset - data.x - data.width);
        }

        function eventPointerLeave(data) {
            const svg = d3.select('#event-index' + (data.index + 1));
            svg.transition()
                .ease('linear')
                .duration(500)
                .attr('width', 0);
        }

        const showModal = this.showModal;

        function eventSelected(data) {
            eventPointerLeave(data);

            let formData = new URLSearchParams();
            formData.set('ids', JSON.stringify(data.articleId));

            const url = 'https://api2.newsminer.net/svc/portraitDaily/getNewsList';

            fetch(url, {
                method: 'post',
                body: formData,
            })
                .then(response => response.json())  ///解析json数据
                .then(result => {
                    showModal(result, data.label)
                })
                .catch(e => console.log('错误:', e));  ///请求出错

        }

        function selectedColor(selected) {
            if (selected) {
                return '#ff7f0e';
            } else {
                return '#8AA396';
            }
        }

        function selectedTextColor(selected) {
            if (selected) {
                return '#ff7f0e';
            } else {
                return '#000000';
            }
        }

        function genLinkPath(link) {
            let sx = link.source.x + link.source.width;
            let tx = link.target.x + link.target.width;
            let sy = link.source.y + link.source.height;
            let ty = link.target.y + link.target.height;
            return 'M' + sx + ',' + sy + ' L' + tx + ',' + ty
        }

        // function pointerenter(data) {
        //     // selected(data);
        //
        //     const eventContainer = d3.select('#eventGraph g.event-container');
        //     const entityContainer = d3.select('#entityGraph g.container');
        //
        //     const svg = d3.select('#event-index' + (data.index + 1));
        //     if (myBrowser() === 'Safari') {
        //         const id = 'event-index' + (data.index + 1);
        //         document.getElementById(id).style.left = (data.x + data.width + offset) + 'px';
        //     }
        //     let list = [];
        //     const color = {
        //         location: '#8345a4',
        //         person: '#99ce7e',
        //         organization: '#e6b34e'
        //     };
        //     const entityTransform = getTransformXY(entityContainer);
        //     data.entities.forEach(entity => {
        //         if (entity.x && entity.y) {
        //             const targetOffsetX = entity.x * entityTransform.scale + entityTransform.x;
        //             const targetOffsetY = entity.y * entityTransform.scale + entityTransform.y;
        //
        //             list.push({
        //                 category: entity.category,
        //                 sourceX: 0,
        //                 //模块位移180，事件条目位移13
        //                 sourceY: data.y + 180 + 12.5 + getTransformXY(eventContainer).y,
        //                 targetX: document.documentElement.clientWidth * 0.3 - (data.x + data.width + offset) + targetOffsetX,
        //                 targetY: document.documentElement.clientHeight * 0.1 + targetOffsetY
        //             })
        //         }
        //     });
        //     svg.selectAll('path').remove();
        //     svg.selectAll('path')
        //         .data(list)
        //         .enter()
        //         .append('path')
        //         .style('stroke', d => color[d.category])
        //         .style('stroke-width', 2)
        //         .style('fill', 'rgba(0,0,0,0)')
        //         .attr('d', d => {
        //             const p0 = {x: d.sourceX, y: d.sourceY};
        //             const p3 = {x: d.targetX, y: d.targetY};
        //             const mx = (p0.x + p3.x) / 2;
        //             let p = [p0, {
        //                 x: mx,
        //                 y: p0.y
        //             }, {
        //                 x: mx,
        //                 y: p3.y
        //             }, p3];
        //
        //             p = p.map(d => [d.x, d.y]);
        //             return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
        //         });
        //     svg.transition()
        //         .ease('linear')
        //         .duration(500)
        //         .attr('width', clientWidth - offset - data.x - data.width);
        // }
        //
        // function pointerleave(data) {
        //     // selected(null);
        //     const svg = d3.select('#event-index' + (data.index + 1));
        //     svg.transition()
        //         .ease('linear')
        //         .duration(500)
        //         .attr('width', 0);
        // }

    };

    hideModal = () => {
        this.setState({
            eventTitle: '',
            newsList: [],
            modalVisible: false
        })
    };

    showModal = (newsList, title) => {
        this.setState({
            eventTitle: title,
            newsList: newsList,
            modalVisible: true
        })
    };

    render() {
        const {modalVisible, eventTitle, newsList} = this.state;

        function redirect(url) {
            return 'https://newsminer.net/link.html?url=' + url;
        }

        const IconText = ({type, text}) => (
            <span><Icon type={type} style={{marginRight: 8}}/> {text}</span>
        );

        return <div id={'eventGraph'} style={{width: '35vw', height: '80vh'}}>
            <Modal
                title={eventTitle + ' (' + newsList.length + ')'}
                visible={modalVisible}
                onCancel={this.hideModal}
                footer={null}
                destroyOnClose
            >
                <List
                    itemLayout={'vertical'}
                    size={'small'}
                    pagination={{
                        pageSize: 5,
                    }}
                    dataSource={newsList}
                    footer={null}
                    renderItem={(item, index) => (
                        <List.Item
                            key={item['newsId']}
                            actions={[
                                <IconText type={'tag'} text={item['category']} key={'category' + index}/>,
                                <IconText type={'clock-circle'} text={item['publishTime']}
                                          key={'publishTime' + index}/>,
                                <IconText type={'global'} text={item['publisher']} key={'publisher' + index}/>,
                            ]}
                        >
                            <a href={redirect(item['url'])} target={'_blank'}>{item['title']}</a>
                        </List.Item>
                    )}
                />
            </Modal>
        </div>
    }
}
